module.exports = __webpack_public_path__ + "img/icon-config-active.b458c566.svg";